import React from "react";
import { cn } from "~/lib/cn";

export const IconD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 81.779891 84.479434"
    version="1.1"
    fill="currentColor"
    className={cn("w-1em", props.className)}
    {...props}
  >
    <path d="M 34.794569,68.677525 C 46.699763,69.984427 59.662091,63.948847 64.150243,52.38178 69.929629,39.254353 62.93952,22.321129 49.314289,17.521584 37.162304,12.679525 20.076882,17.680178 16.19052,31.139338 c -4.071524,7.796879 7.449639,15.876719 12.159644,7.757961 2.507504,-7.838621 10.527535,-5.167091 16.697759,-6.153876 7.552642,0.745184 -1.613388,10.04806 -1.777291,14.43935 -2.839105,7.150205 -5.616758,14.324627 -8.456063,21.474752 m -6.44,15.65 c -5.064756,-0.62542 -13.387889,1.09735 -16.402685,-1.11425 3.583321,-8.366106 6.841304,-16.867063 10.421435,-25.2345 C 10.025936,58.546819 -0.8559191,47.007435 0.0531749,34.724863 0.1346389,17.484494 14.956989,2.8640585 31.679693,0.73707347 48.980394,-2.6159055 67.974359,5.6820835 76.390659,21.325065 c 9.63955,16.831584 6.17071,40.153203 -8.98748,52.641108 -9.047723,8.078552 -21.473881,11.371662 -33.413921,10.324572 -1.871558,-0.005 -3.74329,-0.0106 -5.614689,0.0168 z" />
  </svg>
);
